"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const reactstrap_1 = require("reactstrap");
const components_1 = require("../../../../../shared/components");
const ModalInstituicoesOAI_1 = __importDefault(require("../ModalInstituicoesOAI"));
const react_router_dom_1 = require("react-router-dom");
const RepositorySelectorV2 = ({ selectedTab, onSelect, value, repOptions }) => {
    var _a;
    const [rep, setRep] = (0, react_1.useState)(value);
    const [isOpenModalOtherInst, setIsOpenModalOtherInst] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [repInUrl, setRepInUrl] = (0, react_1.useState)();
    const bindRep = () => {
        const urlSearchParams = new URLSearchParams(history.location.search);
        const repInURL = urlSearchParams.get('rep');
        if (repInURL) {
            setRepInUrl(repInURL);
            setRep(repInURL);
        }
    };
    (0, react_1.useEffect)(() => {
        bindRep();
    }, [history.location]);
    (0, react_1.useEffect)(() => {
        bindRep();
    }, []);
    /* useEffect(() => {
         console.log(repInUrl)
     }, [repInUrl]);*/
    const handleSelectOtherBases = (0, react_1.useCallback)((value, aux) => {
        if (value === 'rede_pergamum_oai' && !aux) {
            setIsOpenModalOtherInst(true);
            setRep(value);
            return;
        }
        else if (value === 'reopen_modal' && rep === 'rede_pergamum_oai') {
            setIsOpenModalOtherInst(true);
            return;
        }
        else if (value === 'cancel') {
            value = '';
        }
        setRep(value);
        if (onSelect !== undefined) {
            onSelect(value, aux);
        }
    }, [rep]);
    return (repOptions === null || repOptions === void 0 ? void 0 : repOptions.length) ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.ModalConstructor, { closeable: true, closeAction: true, size: "xl", title: t('SelecioneInstituicoesPesquisa'), open: isOpenModalOtherInst, setOpen: setIsOpenModalOtherInst },
            react_1.default.createElement(ModalInstituicoesOAI_1.default, { t: t, pesquisarCallback: handleSelectOtherBases })),
        react_1.default.createElement(reactstrap_1.Input, { name: 'rep', type: "select", value: rep || '', onChange: e => handleSelectOtherBases(e.target.value), className: "b-tema20 cortxt rad10 s14" },
            react_1.default.createElement("option", { value: 'local' }, t('BaseLocal')),
            rep === 'rede_pergamum_oai' && !isOpenModalOtherInst ? (react_1.default.createElement(react_1.default.Fragment, null,
                repInUrl === 'rede_pergamum_oai' ? (react_1.default.createElement("option", { value: "rede_pergamum_oai" }, (_a = repOptions.find(x => x.permission === 108)) === null || _a === void 0 ? void 0 : _a.label))
                    : '',
                react_1.default.createElement("option", { value: "reopen_modal" }, "Reabrir modal"),
                react_1.default.createElement("option", { value: "cancel" }, "Selecionar outra op\u00E7\u00E3o"))) : repOptions.map(({ permission, label, value }) => (react_1.default.createElement("option", { value: value, key: permission }, label)))))) : null;
};
exports.default = RepositorySelectorV2;
